import { computed } from 'vue';
import { useSalespointModel } from '.';

export const useLegalForm = () => {
  const salespointModel = useSalespointModel();
  const legalFrom = computed(() => salespointModel?.salespoint?.legal_form);

  const isInd = computed(() => legalFrom.value === 'IND');
  const isSe = computed(() => legalFrom.value === 'SE');
  const isIp = computed(() => legalFrom.value === 'IP');
  const isOOO = computed(() => legalFrom.value === 'OOO');

  return {
    isInd,
    isSe,
    isIp,
    isOOO
  };
};
